module.exports = __webpack_public_path__ + "img/main_bg_top.5143a901.jpg";